import React, { Component } from 'react';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getAuthorProfile, saveAuthorProfile } from "../user-settings-actions.js";
import AuthorProfileForm from '../components/author-profile-form.jsx';
import AppLoader from "../../app-components/app-loader.jsx";


class AuthorProfileView extends Component {
  componentDidMount() {
    if (!localStorage.getItem('accessToken')) {
      this.props.history.push("/login-home/login");
      return;
    }
    this.props.getAuthorProfile();
  }

  onSave = (profileData) => {
    this.props.saveAuthorProfile(profileData);
  }

  render() {
    const { authorProfile, isFetchingAuthorProfile, isSavingAuthorProfile } = this.props;

    if (isFetchingAuthorProfile) {
      return <AppLoader message="Fetching Author Profile..." />;
    }

    return (
      <AuthorProfileForm
        authorProfile={authorProfile}
        onSave={this.onSave}
        isSaving={isSavingAuthorProfile}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    authorProfile: state.userSettings.authorProfile,
    isFetchingAuthorProfile: state.userSettings.isFetchingAuthorProfile,
    isSavingAuthorProfile: state.userSettings.isSavingAuthorProfile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAuthorProfile: () => dispatch(getAuthorProfile()),
    saveAuthorProfile: (data) => dispatch(saveAuthorProfile(data)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthorProfileView));
